import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class AdresseCommandeSAS {
  constructor (
    raisonSociale?: string,
    ligne1?: string,
    ligne2?: string,
    ligne3?: string,
    codepostal?: string,
    ville?: string,
    codeInsee?: string,
    telephoneFixe?: string,
    telephoneMobile?: string
  ) {
    this.raisonSociale = raisonSociale as any;
    this.ligne1 = ligne1 as any;
    this.ligne2 = ligne2 as any;
    this.ligne3 = ligne3 as any;
    this.codepostal = codepostal as any;
    this.ville = ville as any;
    this.codeInsee = codeInsee as any;
    this.telephoneFixe = telephoneFixe as any;
    this.telephoneMobile = telephoneMobile as any;
  }

  @JsonProperty(String)
  raisonSociale?: string;

  @JsonProperty(String)
  ligne1?: string;

  @JsonProperty(String)
  ligne2?: string;

  @JsonProperty(String)
  ligne3?: string;

  @JsonProperty(String)
  codepostal?: string;

  @JsonProperty(String)
  ville?: string;

  @JsonProperty(String)
  codeInsee?: string;

  @JsonProperty(String)
  telephoneFixe?: string;

  @JsonProperty(String)
  telephoneMobile?: string;
}
